import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f19c530"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "center" }
const _hoisted_2 = { class: "player-nick" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "vs", -1))
const _hoisted_4 = { class: "player-nick" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "no-validada partida-en-juego" }, "Esperando la validación del rival", -1))
const _hoisted_9 = [
  _hoisted_8
]

import { ref, onMounted, watch } from "vue";
import {
  ValidarPartidaDTO,
  ViewPartidaAmistosaDTO,
} from "@/interfaces/Partidas";
import { useAuth } from "@/composables/useAuth";
import {
  cancelarPartida,
  ValidarPartida,
} from "@/services/PartidasAmistosasService";
import { formatFechaSpa } from "@/utils/Fecha";
import ModalSuccess from "../Commons/ModalSuccess.vue";
import ModalError from "../Commons/ModalError.vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'PendingMatchCard',
  props: {
    match: {}
  },
  emits: ["close", "registroExitoso"],
  setup(__props: any, { emit: __emit }) {

const isLoading = ref(false);
const { getUser, getidUsuario } = useAuth();
const validarPartidaDTO = ref<ValidarPartidaDTO>();
const IsValidadaRival = ref<boolean>(false);
const IsValidadaOwner = ref<boolean>(false);
const emailUsuario = ref<string>(getUser.value ?? "null");
const idUsuarioOwner = ref<string>(getidUsuario.value ?? "null");
const router = useRouter();

const showSuccessValidarModal = ref<boolean>(false);
const showErrorValidarModal = ref<boolean>(false);

const showSuccessCancelarModal = ref<boolean>(false);
const showErrorCancelarModal = ref<boolean>(false);

const fechaPartidaFormateada = ref<string>("");

const props = __props;
const emit = __emit;

onMounted(async () => {
  isLoading.value = true;

  try {
    fechaPartidaFormateada.value = await formatFechaSpa(
      props.match.fechaPartida
    );

    controlValidacionesPartidas();
  } catch (err) {
    console.error(err);
  } finally {
    isLoading.value = false;
  }
});

const validarPartida = async () => {
  isLoading.value = true;
  validarPartidaDTO.value = {
    emailJugador: emailUsuario.value,
    idPartida: props.match.idPartidaAmistosa,
  };
  try {
    await ValidarPartida(validarPartidaDTO.value);
    showSuccessValidarModal.value = true;
  } catch (error) {
    console.error(error);
    showErrorValidarModal.value = true;
  } finally {
    isLoading.value = false;
  }
};

const verProfileUser = (idUser: number) => {
  router.push({ name: "detalle-jugador", params: { idUsuario: idUser } });
};

const cancelPartida = async () => {
  try {
    isLoading.value = true;
    await cancelarPartida(props.match.idPartidaAmistosa);
    showSuccessCancelarModal.value = true;
  } catch (err) {
    showErrorCancelarModal.value = true;
  } finally {
    isLoading.value = false;
  }
};

watch([showSuccessValidarModal], ([newshowSuccessValidarModal]) => {
  if (!newshowSuccessValidarModal) {
    emit("registroExitoso");
  }
});
watch([showSuccessCancelarModal], ([newshowSuccessCancelarModal]) => {
  if (!newshowSuccessCancelarModal) {
    emit("registroExitoso");
  }
});

const controlValidacionesPartidas = () => {
  if (
    parseInt(idUsuarioOwner.value) == props.match.idUsuario1 &&
    props.match.partidaValidadaUsuario1
  ) {
    IsValidadaOwner.value = true;
  }

  if (
    parseInt(idUsuarioOwner.value) == props.match.idUsuario2 &&
    props.match.partidaValidadaUsuario2
  ) {
    IsValidadaOwner.value = true;
  }
  if (
    parseInt(idUsuarioOwner.value) != props.match.idUsuario1 &&
    props.match.partidaValidadaUsuario1
  ) {
    IsValidadaRival.value = true;
  }

  if (
    parseInt(idUsuarioOwner.value) != props.match.idUsuario2 &&
    props.match.partidaValidadaUsuario2
  ) {
    IsValidadaRival.value = true;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isLoading.value)
      ? (_openBlock(), _createBlock(_component_v_card, {
          key: 0,
          class: _normalizeClass(['match-card'])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_title, { class: "text-center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  align: "center",
                  justify: "center",
                  class: "match-score",
                  "no-gutters": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (verProfileUser(_ctx.match.idUsuario1))),
                      cols: "5",
                      class: "player-name text-center"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.match.nickUsuario1), 1),
                        _createVNode(_component_v_card_subtitle, { class: "text-wrap" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.match.ejercitoUsuario1), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "2",
                      class: "score text-center marcador"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3,
                        _createElementVNode("p", null, _toDisplayString(_ctx.match.resultadoUsuario1) + "-" + _toDisplayString(_ctx.match.resultadoUsuario2), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (verProfileUser(_ctx.match.idUsuario2))),
                      cols: "5",
                      class: "player-name text-right"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.match.nickUsuario2), 1),
                        _hoisted_5,
                        _createVNode(_component_v_card_subtitle, { class: "text-wrap" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.match.ejercitoUsuario2), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { align: "center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "6",
                      class: "text-center"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.match.puntosPartida) + " pts ", 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "6",
                      class: "player-nick"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(fechaPartidaFormateada.value), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, { class: "mt-3 match-scenario" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "text-center"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.match.escenarioPartida || "Escenario no disponible"), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { style: {"font-family":"'Roboto', sans-serif"} }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "6",
                      class: "text-center"
                    }, {
                      default: _withCtx(() => [
                        (!IsValidadaOwner.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              _createVNode(_component_v_btn, {
                                color: "success",
                                onClick: validarPartida,
                                variant: "tonal"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, { left: "" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("mdi-check")
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode(" Validar Resultado ")
                                ]),
                                _: 1
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "6",
                      class: "text-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          disabled: isLoading.value,
                          variant: "tonal",
                          color: "red darken-1",
                          onClick: cancelPartida,
                          block: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { left: "" }, {
                              default: _withCtx(() => [
                                _createTextVNode("mdi-close")
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" Cancelar ")
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_v_progress_circular, {
          key: 1,
          indeterminate: "",
          color: "blue darken-1"
        })),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessValidarModal.value,
      message: "Partida validada con exito.",
      "onUpdate:isVisible": _cache[2] || (_cache[2] = ($event: any) => (showSuccessValidarModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorValidarModal.value,
      message: "No se ha podido validar la partida. Contacta con el administrador.",
      "onUpdate:isVisible": _cache[3] || (_cache[3] = ($event: any) => (showErrorValidarModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessCancelarModal.value,
      message: "Partida cancelada con exito.",
      "onUpdate:isVisible": _cache[4] || (_cache[4] = ($event: any) => (showSuccessCancelarModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorCancelarModal.value,
      message: "No se ha podido cancelar la partida. Contacta con el administrador.",
      "onUpdate:isVisible": _cache[5] || (_cache[5] = ($event: any) => (showErrorCancelarModal.value = $event))
    }, null, 8, ["isVisible"])
  ]))
}
}

})